import { render, staticRenderFns } from "./TimePeriodFormat.vue?vue&type=template&id=23b8a4e6"
import script from "./TimePeriodFormat.vue?vue&type=script&lang=js"
export * from "./TimePeriodFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports